import React from 'react';

import { MeetTheTeam } from './MeetTheTeam';

import '../../../css/components/about-us/about-us-page.scss';
export function AboutUsPage() {
  window.scrollTo(0,0);
  return (
    <div className="AboutUsPage">
      <MeetTheTeam/>
    </div>
  )
}